import type { IconProps } from './types';
import './icons.css';

export default function CloseCircle({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-close-circle ${className || ''}`}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 14.667A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333ZM5.972 5.029a.667.667 0 1 0-.943.943L7.057 8 5.03 10.03a.667.667 0 1 0 .943.943L8 8.943l2.029 2.029a.667.667 0 0 0 .943-.943L8.943 8l2.029-2.028a.667.667 0 0 0-.943-.943L8 7.057 5.972 5.03Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
